export default __webpack_public_path__ + "static/media/吴杰庄议员办公区_white.a1ff628a.jpg";